import React from "react";
import "./FieldRow.scss";

export const FieldRow = React.memo(({ label, value, isMarked, onToggle, fieldKey, incorrectLabel, markAsIncorrectLabel, hideCheckbox }) => {
  return (
    <div className={`field-row ${isMarked ? "field-row--marked" : ""}`}>
      <div className="field-row__content">
        <span className="field-row__label">{label}</span>
        <p className="field-row__data">{value || "-"}</p>
      </div>
      {!hideCheckbox && (
        <label className="field-row__checkbox-wrapper">
          <input
            type="checkbox"
            checked={isMarked}
            onChange={(e) => onToggle(fieldKey, e.target.checked)}
            className="field-row__checkbox"
            aria-label={`${markAsIncorrectLabel} ${label}`}
            id={`field-${fieldKey}`}
          />
          <span className="field-row__checkbox-label">{incorrectLabel}</span>
        </label>
      )}
    </div>
  );
});

FieldRow.displayName = "FieldRow";
